import { useTypedParams } from "react-router-typesafe-routes";
import { useCallback, useState } from "react";

import { TableColumnSettingsProvider } from "@providers/TableColumnSettingsProvider/TableColumnSettingsProvider";

import { ResourceGroupEmployeesTable } from "@components/Tables/ResourceGroupEmployeesTable/ResourceGroupEmployeesTable";

import { Box } from "@design-system/Box/Box";
import { Search } from "@design-system/Search/Search";

import { PortalHeaderActions } from "@layouts/PortalPage/PortalHeaderActions";

import { routes } from "@pages/routes";

// Define default settings since we don't have a config file for this table yet
const defaultColumnSettings = {
  name: true,
  email: true,
};
const defaultColumnOrder = ["name", "email"];

export const ApplicationUsers = () => {
  const { clientId, applicationId } = useTypedParams(
    routes.portal.clients.client.applications.application.users,
  );
  
  const [search, setSearch] = useState("");

  const handleSearchChange = useCallback((value: string) => {
    setSearch(value);
  }, []);

  return (
    <TableColumnSettingsProvider
      tableId="application-users"
      defaultColumnSettings={defaultColumnSettings}
      defaultColumnOrder={defaultColumnOrder}
    >
      <Box direction="column" fullStretch>
        <PortalHeaderActions>
        <Box direction="row" gap={8} align="center">
          <div style={{ width: 300 }}>
            <Search onChange={handleSearchChange} />
          </div>
        </Box>
        </PortalHeaderActions>
        <ResourceGroupEmployeesTable
          clientId={clientId}
          clientApplicationId={applicationId}
          search={search}
        />
      </Box>
    </TableColumnSettingsProvider>
  );
};
